import { Control, Controller, FieldPath } from 'react-hook-form';

import { TeamNanoID } from '../../../../../../../../../../teams/teamsTypes';

import { PureTooltipIconButtonHelper } from '../../../../../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { IconsEnum } from '../../../../../../../../../../../assets/icons/types';
import { invoicesKeys } from '../../../../../../../../../../../locales/keys';

interface CreateProjectInTeamFormItemsTableRowGroupedFieldProps<T> {
  companyNanoId: TeamNanoID;
  control: Control<T>;
  fieldName: FieldPath<T>;
}

function CreateProjectInTeamFormItemsTableRowGroupedField<T>({
  companyNanoId,
  control,
  fieldName
}: CreateProjectInTeamFormItemsTableRowGroupedFieldProps<T>) {
  return (
    <Controller
      control={control}
      name={fieldName}
      render={({ field: { onChange, value, name } }) => (
        <PureTooltipIconButtonHelper
          dataGa={name}
          className="p-0.5 rounded-md inline-flex items-center leading-5 focus:ring-base hover:text-gray-950 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 focus:ring-offset-0 transition-colors duration-150 ease-out"
          icon={
            value
              ? IconsEnum.SQUARE_COMBINED_SOLID
              : IconsEnum.SQUARE_SEPARATE_SOLID
          }
          iconClassName={value ? 'h-5 w-5 text-blue-500' : 'h-5 w-5'}
          tooltipI18nText={
            value ? invoicesKeys.combinedInvoice : invoicesKeys.separateInvoices
          }
          onClick={() => onChange(!value)}
          disabled={!companyNanoId}
        />
      )}
    />
  );
}

export default CreateProjectInTeamFormItemsTableRowGroupedField;
